//Helpers
import { convertToUnit } from 'src/helpers/units_helpers';
import { translateTemplateTitle } from '../template_helpers';
//Types
import type { VirtualComponentInterfaceData, VCInterfaceStatus } from 'src/types/VirtualComponents';

export const updateThermostatsStatus = (
	interface_data: VCInterfaceStatus[],
	data: VCInterfaceStatus,
	valueData: VirtualComponentInterfaceData,
): void => {
	const { role, config } = data;
	if (/^(target_humidity|target_temperature)$/.test(role)) {
		data.min = config.min;
		data.max = config.max;
		data.step = config?.meta?.ui?.step;
	} else if (role === 'heater_relay_status') {
		data.iconColor = valueData.value ? '--color-danger' : '--color-3';
	}
	interface_data.push({
		...data,
		hasAction: true,
		event: valueData.event !== null ? valueData.event : valueData.value,
		value:
			role === 'heater_relay_status'
				? null
				: translateTemplateTitle(valueData.label) ||
					convertToUnit(valueData.value, valueData.unit || ''),
		hideLabel: !/^(curr_temperature|current_temperature|humidity|current_humidity)$/.test(role),
	});
};
